<template>
    <div class="mt-6 content">
        <h3 class="has-text-white"><i class="fad fa-fw fa-file-certificate mr-3"></i>Certifications & Forms</h3>

        <div class="mt-6 pb-6" ref="top">
            <router-view/>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['enrollmentId'],
        data: function() {
            return {};
        }
    };
</script>

<style lang="scss" scoped>

</style>
